import React from 'react';
import Transactions from '@components/transactions/transactions';

import { useAppSelector } from '@store/hooks';

import { IUserSession } from '@entities/user-session';

import { serverFetch } from '@flp/server';
import { Currency } from '@enums/currency';

const TransactionsHistory = () => {
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    return (
        <Transactions
            userId={userSession.userId}
            hideInitiator={true}
            isViewMode={true}
            useTagRequired={userSession.useTagRequired}
            tag={userSession.tag}
            currency={Currency.Eur}
            serverFetch={serverFetch}
        />
    );
};

export default TransactionsHistory;
